/**
 * 에러를 사용자 친화적인 메시지로 변환하는 유틸리티
 */
export function getErrorMessage(error: unknown): string {
  if (!(error instanceof Error)) {
    return '알 수 없는 오류가 발생했습니다.';
  }

  // Supabase Functions 에러에서 실제 에러 메시지 추출
  let message = error.message;
  
  // error 객체에 context나 다른 필드가 있는지 확인
  const errorAny = error as Error & { context?: unknown; data?: unknown };
  
  if (errorAny.context) {
    try {
      const context = typeof errorAny.context === 'string' 
        ? JSON.parse(errorAny.context) 
        : errorAny.context;
      
      if (context && typeof context === 'object') {
        if (context.error) {
          message = context.error;
        } else if (context.message) {
          message = context.message;
        }
      }
    } catch {
      // JSON 파싱 실패 시 무시
    }
  }
  
  // data 필드에서도 에러 메시지 추출 시도
  if (errorAny.data) {
    try {
      const data = typeof errorAny.data === 'string' 
        ? JSON.parse(errorAny.data) 
        : errorAny.data;
      
      if (data && typeof data === 'object') {
        if (data.error) {
          message = data.error;
        } else if (data.message) {
          message = data.message;
        }
      }
    } catch {
      // JSON 파싱 실패 시 무시
    }
  }
  
  // 메시지에 JSON이 포함된 경우 파싱 시도
  if (message.includes('{') && message.includes('}')) {
    try {
      const jsonMatch = message.match(/\{.*\}/);
      if (jsonMatch) {
        const parsed = JSON.parse(jsonMatch[0]);
        if (parsed.error) {
          message = parsed.error;
        } else if (parsed.message) {
          message = parsed.message;
        }
      }
    } catch {
      // JSON 파싱 실패 시 원본 메시지 사용
    }
  }
  
  // 서버 에러 메시지를 사용자 친화적으로 변환
  const errorMap: Record<string, string> = {
    'Unauthorized': '로그인이 필요합니다. GitHub로 로그인해주세요.',
    'Profile not found': '프로필을 찾을 수 없습니다. 잠시 후 다시 시도해주세요.',
    'Already claimed today': '오늘은 이미 재화를 받으셨습니다. 내일 다시 시도해주세요.',
    'GitHub username not set': 'GitHub 사용자 이름이 설정되지 않았습니다.',
    'Failed to update currency': '재화 업데이트에 실패했습니다. 잠시 후 다시 시도해주세요.',
    'Insufficient currency': '재화가 부족합니다.',
    'Not enough currency': '재화가 부족합니다.',
    'Invalid pulls': '소환 횟수는 1회부터 10회까지 가능합니다.',
  };

  // 정확한 매칭 시도
  if (errorMap[message]) {
    return errorMap[message];
  }

  // 부분 매칭 (대소문자 무시)
  const lowerMessage = message.toLowerCase();
  for (const [key, value] of Object.entries(errorMap)) {
    if (lowerMessage.includes(key.toLowerCase())) {
      return value;
    }
  }

  // Supabase 기본 에러 메시지 처리
  if (lowerMessage.includes('edge function returned a non-2xx status code')) {
    return '서버 오류가 발생했습니다. 잠시 후 다시 시도해주세요.';
  }

  // 매핑되지 않은 경우 원본 메시지 반환 또는 기본 메시지
  return message || '알 수 없는 오류가 발생했습니다. 잠시 후 다시 시도해주세요.';
}

